module.exports = __webpack_public_path__ + "static/media/ESCALERASERIESF.cb9e3263.jpg";